import {Component, Injector, Input, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {ScorecardService} from "../../_services/scorecard.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'my-assessment',
    templateUrl: './my-assessment.component.html',
})
export class MyAssessmentComponent extends BasePageComponentDirective<any> implements OnInit {
    scorecards: any[] = [];
    attendanceTypes: any = {};
    @Input() user: any;
    userId: any = null;

    constructor(
        injector: Injector,
        private scorecardService: ScorecardService,
    ) {
        super(injector);
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['competitionLevel'];
        this.scorecardService.getAllUser(this.pageQuery).then(r => {
            this.scorecards = r.content;
            this.page.emit(r);

        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.userId = this.activatedRoute.snapshot.params.id;
        this.query();

    }

    seeDetail(d: any) {
        this.router.navigate(['/my-wallet/scorecard/'+d.id+'/view']).then()
    }

}